import classNames from 'classnames';

export const TestID = 'HPICoverageQuestionBubble.TestID';

export const visitProviderKnowledgeCenterLinkClassName = classNames(
  'flex',
  'w-full',
  'font-extrabold',
  'justify-center',
  'text-white',
  'p-4',
  'rounded',
  'hover:shadow-md',
  'bg-blue-200',
  'whitespace-no-wrap',
  'mt-2',
);
